import { FC } from 'react';
import { createPortal } from 'react-dom';
import { Modal } from '../../../components/modal/modal';
import { PortalProps } from './types';

export const FullScreenPortal: FC<PortalProps> = (props) => {
  const { children, onClose, className, triggerRef, closeOnContentClick } = props;

  const trigger = triggerRef.current;

  if (!trigger) return null;

  return createPortal(
    <Modal
      onClose={onClose}
      onClick={() => closeOnContentClick && onClose()}
      className={className}
      style={{
        minWidth: 0,
        padding: 12,
        border: 0,
        minHeight: 0,
        gap: 10,
        width: 'auto',
      }}
    >
      {children}
    </Modal>,
    trigger,
  );
};
